import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { ElProgress } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'CandidateProgress',
  props: {
    percentage: { default: 0 },
    kind: { default: 'line' },
    size: { default: 'medium' },
    tone: { default: 'primary' }
  },
  setup(__props: any) {

const props = __props

const normalizedPercentage = computed(() => Math.min(100, Math.max(0, props.percentage)))
const circleWidth = computed(() => (props.size === 'large' ? 150 : props.size === 'small' ? 84 : 112))
const strokeWidth = computed(() => (props.size === 'large' ? 12 : props.size === 'small' ? 6 : 8))
const progressColor = computed(() => {
  const colors = {
    default: '#8391a5',
    primary: '#1768e5',
    success: '#1faf7a',
    warning: '#f58a2d',
    danger: '#ef5b68',
  }
  return colors[props.tone]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElProgress), _mergeProps({
    percentage: normalizedPercentage.value,
    type: _ctx.kind,
    width: circleWidth.value,
    "stroke-width": strokeWidth.value,
    color: progressColor.value
  }, _ctx.$attrs), null, 16, ["percentage", "type", "width", "stroke-width", "color"]))
}
}

})